export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/index-legacy.8529de87.worker.js");
}
